<script>
import {defineComponent} from 'vue'
import {ElNotification} from "element-plus";
import moment from "moment";

export default defineComponent({
  name: "EconomicIndicatorForm",
  props: {
    id: {
      type: Number
    },
    economic_classification_id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      form: {
        id: null,
        economic_classification_id: null,
        year: moment(Date.now()).format("YYYY"),
        quarter: null,
        amount: null,
      },
      quarters: [
        {value: 1},
        {value: 2},
        {value: 3},
        {value: 4}
      ],
      dialogTableVisible: false,
      rules: {
        year: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        quarter: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        amount: [{required: true, message: "Majburiy maydon", trigger: "blur"}]
      }
    }
  },
  methods: {
    onClick() {
      this.form = {
        id: null,
        economic_classification_id: null,
        year: moment(Date.now()).format("YYYY"),
        quarter: null,
        amount: null,
      }
      this.dialogTableVisible = true;
      this.form.economic_classification_id = this.economic_classification_id;
      if (this.id) {
        this.form.id = this.id;
        this.getExpenseIndicatorById();
      }
    },
    getExpenseIndicatorById() {
      this.loading = true;
      this.$http
          .get(`/api/v1/economic-classification-indicators/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
            this.form.year = data.year.toString()
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.form.year = Number(this.form.year)
          let http;
          if (this.form.id) {
            http = this.$http.put(`/api/v1/economic-classification-indicators/${this.form.id}`, this.form);
          } else {
            http = this.$http.post("/api/v1/economic-classification-indicators", this.form);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.dialogTableVisible = false;
                this.$emit('getData')
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    }
  },
})
</script>

<template>
  <el-button v-if="id" type="primary" size="small" @click="onClick">
    Tahrirlash
  </el-button>
  <el-button v-else type="primary" size="small"
             @click="onClick">Qo'shish
  </el-button>
  <el-dialog
      v-model="dialogTableVisible"
      append-to-body
      destroy-on-close
      :title="id?'Ko\'rsatgichni tahrirlash':'Ko\'rsatgich qo\'shish'" width="800">
    <div class="main-data" v-loading="loading">
      <el-row>
        <el-col :span="24">
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Yilni tanlang" prop="year">
                  <el-date-picker
                      size="large"
                      style="width: 100%"
                      v-model="form.year"
                      type="year"
                      format="YYYY"
                      value-format="YYYY"
                      placeholder="Yilni tanlang"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Chorakni tanlang" prop="quarter">
                  <el-select class="form-input" v-model="form.quarter" size="large"
                             style="margin-right: 10px;width: 100%"
                             placeholder="Chorakni tanlang">
                    <el-option v-for="item in quarters"
                               :value="item.value"
                               :label="item.value"
                               :key="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
                <el-form-item label="Miqdorni kiriting" prop="amount">
                  <el-input size="large" v-model.number="form.amount" type="number"/>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item>
                  <el-button size="small" class="custom-btn" @click="() => dialogTableVisible=false"
                  >Yopish
                  </el-button
                  >
                  <el-button size="small" class="custom-btn" type="primary" @click="onSubmit"
                  >Saqlash
                  </el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<style scoped>

</style>
